enum TipoNotificacaoEnum {
    SolicAprovPlanoAtividade = 1,
    RespSolicAprovPlanoAtividade,
    AtivacaoUsuario,
    AtualizacaoAgendaDocente,
    AtualizacaoPlanoAtividadeDocente,
    AceiteTermoDiretriz,
    AtualizacaoCargaHorariaDocente,
    PeriodoBloqueioPlanoAtividade,
    ActivityManagement = 12,
    AtualizacaoDeHorasLetivaRe = 13,
}

const TipoNotificacaoEnumLabel = new Map<TipoNotificacaoEnum, string>([
    [
        TipoNotificacaoEnum.SolicAprovPlanoAtividade,
        "Solicitação Aprovação TACH",
    ],
    [
        TipoNotificacaoEnum.RespSolicAprovPlanoAtividade,
        "Resposta Solicitação Aprovação TACH",
    ],
    [TipoNotificacaoEnum.AtivacaoUsuario, "Ativação usuário"],
    [
        TipoNotificacaoEnum.AtualizacaoAgendaDocente,
        "Atualização Agenda Docente",
    ],
    [
        TipoNotificacaoEnum.AtualizacaoPlanoAtividadeDocente,
        "Atualização TACH Docente",
    ],
    [TipoNotificacaoEnum.AceiteTermoDiretriz, "Aceite do Termo Diretriz"],
    [
        TipoNotificacaoEnum.AtualizacaoCargaHorariaDocente,
        "Atualização da carga horária docente",
    ],
    [
        TipoNotificacaoEnum.PeriodoBloqueioPlanoAtividade,
        "Periodo Bloqueio TACH",
    ],
    [TipoNotificacaoEnum.ActivityManagement, "Gestão de Atividades"],
    [
        TipoNotificacaoEnum.AtualizacaoDeHorasLetivaRe,
        "Atualização de Horas Letiva RE",
    ],
]);

export { TipoNotificacaoEnum, TipoNotificacaoEnumLabel };
